<template>
    <div class="w-full">
        <websocket-watcher
            :channel="wsChannel"
            @message="handleAuctionUpdate"
            @connected="setConnectedToRealtimeService"
        />
        <div class="inline">
            <page-headline>{{$t('pages.dashboard.index.dashboard')}}</page-headline>
        </div>
        <todays-top-auction
            class="pt-10"
            :auction="auction"
            :current-level="currentLevel"
            :next-level="nextLevel"
            :current-level-planned-quantity="currentLevel !== null ? currentLevel.quantity : 0"
        />
        <tta-performance
            class="pt-10"
            :lastThirtyPyramidAuctions="lastThirtyPyramidAuctions"
        />
    </div>
</template>

<script>
    import Layout from '@/Shared/Layout';
    import PageHeadline from '@/Shared/PageHeadline';
    import WebsocketWatcher from "@/Shared/WebsocketWatcher";
    import AudiencePanel from "./Components/AudiencePanel";
    import AuctionsCount from "./Components/AuctionsCount";
    import TodaysTopAuction from "./Components/TodaysTopAuction";
    import TtaPerformance from "./Components/TtaPerformance";
    import Icon from '@/Shared/Icon';

    export default {
        layout: Layout,
        components: {
            PageHeadline,
            Icon,
            WebsocketWatcher,
            AudiencePanel,
            AuctionsCount,
            TodaysTopAuction,
            TtaPerformance
        },
        props: {
            auctions: Object,
            auction: Object,
            currentLevel: Object,
            nextLevel: Object,
            lastThirtyPyramidAuctions: Array,
            wsChannel: {
                type: String,
                default: null
            }
        },
        data() {
          return {
              /**
               * Connection to ably established? Being set by event from websocketWatcher component
               */
              connected: false
          };
        },
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.index.dashboard')
            }
        },
        methods: {
            handleAuctionUpdate(e) {
                if (!e.name.match(/^Auction/) && e.data.auction.id !== this.auction.id) {
                    return;
                }
                if (this.connected) {
                    this.$inertia.reload({preserveScroll: true, only: ['auction', 'activeUserStats', 'currentUserStats', 'trendStats', 'lastActivity']});
                }
            },
            setConnectedToRealtimeService(status) {
                this.connected = status;
            },
            countRunningAuctions() {
                return this.auctions.stats.auctions_quantity;
            },
            sumBids() {
              return this.auctions.stats.bids_quantity;
            },
            sumCustomers() {
              return this.auctions.stats.unique_customers;
            }
        }
    }
</script>
